// lib/sentry.js
// Thin Sentry wrapper — initialises error monitoring as early as possible.
// Only active in staging and production; silently skips in local dev.

import * as Sentry from "@sentry/browser";

const ENV = __REWARDLIX_DEPLOY_ENV__;
const VERSION = __REWARDLIX_DEPLOY_VERSION__;

const DSN =
  "https://2881332ba514cb691834eae5295c292c@o4511285569191936.ingest.de.sentry.io/4511285646721104";

if (ENV !== "development") {
  Sentry.init({
    dsn: DSN,
    environment: ENV,
    release: VERSION,
    sendDefaultPii: false,
  });
}

/**
 * Capture an exception and send it to Sentry.
 * Safe to call in all environments — no-ops in development.
 *
 * @param {unknown} err - The error to capture.
 * @param {object} [context] - Optional extra context (key/value pairs).
 */
export function captureException(err, context) {
  if (ENV === "development") return;
  Sentry.withScope((scope) => {
    if (context) scope.setExtras(context);
    Sentry.captureException(err);
  });
}
